import { Constant } from './constant';

export class Rest {
    static getHeaders(type: string) {
        const token = localStorage.getItem("bearerToken");
        const APPLICATION_FORM_URL_ENCODEDE_WITH_BEARER_TOKEN = 'APPLICATION_FORM_URL_ENCODEDE_WITH_BEARER_TOKEN';
        const APPLICATION_JSON_WITH_BEARER_TOKEN = 'APPLICATION_JSON_WITH_BEARER_TOKEN';
        const APPLICATION_FORM_URL_ENCODEDE_WITHOUT_BEARER_TOKEN = 'APPLICATION_FORM_URL_ENCODEDE_WITHOUT_BEARER_TOKEN';
        const APPLICATION_JSON_WITHOUT_BEARER_TOKEN = 'APPLICATION_JSON_WITHOUT_BEARER_TOKEN';
        const APPLICATION_FORM_URL_ENCODED_WITH_BASIC_AUTHENTICATION = 'APPLICATION_FORM_URL_ENCODED_WITH_BASIC_AUTHENTICATION';
        const MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN = 'MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN';
        const MULTIPART_FORMDATA_WITH_BEARER_TOKEN = 'MULTIPART_FORMDATA_WITH_BEARER_TOKEN';
        let headers = {};
        switch (type) {
            case APPLICATION_JSON_WITH_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
                return headers;
            case APPLICATION_JSON_WITHOUT_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'application/json',
                }
                return headers;
            case MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'multipart/form-data',
                }
                    return headers;
            case MULTIPART_FORMDATA_WITH_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + token
                }
                    return headers;
            case APPLICATION_FORM_URL_ENCODEDE_WITH_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer ' + token
                }
                return headers;
            case APPLICATION_FORM_URL_ENCODEDE_WITHOUT_BEARER_TOKEN:
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
                return headers;
            case APPLICATION_FORM_URL_ENCODED_WITH_BASIC_AUTHENTICATION:
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Basic YXRzYXV0aDphdHNhdXRoc2VjcmV0',
                }
                return headers;
            default:
                return headers;
        }
    }
}
export enum RestHeader {
    APPLICATION_FORM_URL_ENCODEDE_WITH_BEARER_TOKEN = 'APPLICATION_FORM_URL_ENCODEDE_WITH_BEARER_TOKEN',
    APPLICATION_JSON_WITH_BEARER_TOKEN = 'APPLICATION_JSON_WITH_BEARER_TOKEN',
    APPLICATION_FORM_URL_ENCODEDE_WITHOUT_BEARER_TOKEN = 'APPLICATION_FORM_URL_ENCODEDE_WITHOUT_BEARER_TOKEN',
    APPLICATION_JSON_WITHOUT_BEARER_TOKEN = 'APPLICATION_JSON_WITHOUT_BEARER_TOKEN',
    MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN = 'MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN',
    MULTIPART_FORMDATA_WITH_BEARER_TOKEN = 'MULTIPART_FORMDATA_WITH_BEARER_TOKEN',
    APPLICATION_FORM_URL_ENCODED_WITH_BASIC_AUTHENTICATION = 'APPLICATION_FORM_URL_ENCODED_WITH_BASIC_AUTHENTICATION'
}